















































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { addPosition, getPositionTree, getPositionDetail } from '@/api/system'
@Component({
  name: 'AddOrgModal',
  data() {
    return {
      form: this.$form.createForm(this)
    }
  }
})

export default class AddBasicModal extends Vue {

  @Prop({ type: Object }) readonly NodePostTreeItem!: any;

  @Prop({ type: String }) readonly SelectTreeItem!: string;

  @Prop({ type: Number }) readonly status!: number;

  @Prop({ type: Boolean }) readonly visible!: number;


  private form: any

  private TData: any = []

  private formItemLayout: any = {
    labelCol: { span: 6 },
    wrapperCol: { span: 17 },
  }

  get title() {
    return this.status === 1 ? '添加职位' : '编辑职位'
  }

  public created(){
    if(this.status === 1){
      this.$nextTick(() => {
        this.form.setFieldsValue({
          parentId: this.NodePostTreeItem.title
        })
      })
    }
    if(this.status === 2 && !this.NodePostTreeItem.parentId){
      this.$nextTick(() => {
        this.form.setFieldsValue({
          positionName: this.NodePostTreeItem.title
        })
      })
    }
    if (this.status === 2 && this.NodePostTreeItem.parentId) {
      this.getRoleDetail()
    }
    this.getPoiTree()
  }

   // 获取职位树

  private getPoiTree() {
    getPositionTree().then((res: any) => {
      if (res && res.status === 0 ) {
        this.TData = [res.data]
        this.TData = this.findIds(this.TData, this.NodePostTreeItem.id)
      }
    })
  }
   private findIds(data: any[], id?: any) {
    const list: any = []
    const setChild = (arr: any) => {
      arr.forEach((node: any) => {
        if (node.children && node.children.length > 0) {
          node.disabled = true
          setChild(node.children)
        } else {
          node.disabled = true
        }
      })
    }
    data.forEach((item: any) => {
      if (item.id === id) {
        item.disabled = true
        if (item.children && item.children.length > 0) {
          setChild(item.children)
        }
      } else {
        if (item.children && item.children.length > 0) {
          this.findIds(item.children, id)
        }
      }
    })
    return data
  }

  private async getRoleDetail() {
    try {
      const { data } = await getPositionDetail(this.NodePostTreeItem.id)
      this.$nextTick(() => {
        this.form.setFieldsValue({
          parentId: data.parentId,
          positionName: data.positionName,
        })
      })

    } catch (error:any) {
      throw new Error(error.message)
    }
  }


  public handleOk(): void {
    this.form.validateFields({force: true}, (err: any, values: any) => {
      if (!err) {
         if (this.status === 1) {
          values.parentId = this.NodePostTreeItem.id
         }else {
           values.id = this.NodePostTreeItem.id,
           values.parentId = this.NodePostTreeItem.parentId
          //  values.parentId = this.form.getFieldValue('parentId')
         }
         const msg: string = this.status === 1 ? '添加成功' : '编辑成功'
         addPosition(values).then((res: any) => {
           if (res && res.status === 0) {
              this.$message.success(msg)
           } else {
             this.$notification.error({
               message: '错误',
               description: res.message
             })
           }
           setTimeout(() => {
              this.$emit('update:visible',false)
              this.$emit('closeModal2')
           }, 500)
         })
      }
    })
  }

  private changePosi(val: string) {
    this.NodePostTreeItem.parentId = val
  }

  public handleCancel(): void {
    this.$emit('update:visible',false)
  }
}
